export const CategoryBannerSkeleton = () => (
  <div className="animate-pulse">
    <div className="flex gap-4 w-full">
      {/* Desktop: Main content area (75.8%) */}
      <div className="w-full sm:w-[75.8%] flex flex-col gap-4">
        {/* Mobile: First post */}
        <div className="sm:hidden flex flex-col gap-2 pb-10">
          <div className="h-[192px] w-full rounded bg-neutral-200" />
          <div className="h-5 w-3/4 rounded bg-neutral-200" />
        </div>

        {/* Desktop: FeaturedPost skeleton */}
        <div className="hidden sm:flex w-full items-stretch">
          <div className="w-2/3 h-[300px] rounded bg-neutral-200" />
          <div className="w-1/3 bg-[#f5f5f5] flex flex-col gap-1 py-6 px-[22px]">
            <div className="h-6 w-full rounded bg-neutral-200" />
            <div className="h-4 w-full rounded bg-neutral-200 mt-2" />
            <div className="h-4 w-5/6 rounded bg-neutral-200 mt-2" />
            <div className="h-4 w-3/4 rounded bg-neutral-200 mt-2" />
            <div className="h-4 w-2/3 rounded bg-neutral-200 mt-4" />
          </div>
        </div>

        {/* Mobile: Top Banner skeleton */}
        <div className="sm:hidden h-32 w-full rounded bg-neutral-200" />

        {/* Mobile: Next 3 posts */}
        <div className="sm:hidden grid grid-cols-1 gap-[26px] pt-[13px] pb-[26px]">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="flex flex-row gap-2">
              <div className="h-[70px] w-[42.8%] rounded bg-neutral-200" />
              <div className="flex flex-col gap-[6px] w-[57.2%]">
                <div className="h-5 w-full rounded bg-neutral-200" />
                <div className="h-4 w-3/4 rounded bg-neutral-200" />
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: Grid posts (md:grid-cols-2 lg:grid-cols-3) */}
        <div className="hidden sm:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="flex flex-col gap-2.5">
              <div className="h-[163px] w-full rounded bg-neutral-200" />
              <div className="h-5 w-full rounded bg-neutral-200" />
              <div className="h-4 w-5/6 rounded bg-neutral-200" />
              <div className="h-4 w-2/3 rounded bg-neutral-200" />
              <div className="h-4 w-1/2 rounded bg-neutral-200" />
            </div>
          ))}
        </div>

        {/* Mobile: Bottom Banner skeleton */}
        <div className="sm:hidden h-32 w-full rounded bg-neutral-200" />

        {/* Mobile: Rest posts */}
        <div className="sm:hidden grid grid-cols-1 gap-6">
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="flex flex-row gap-2">
              <div className="h-[70px] w-[42.8%] rounded bg-neutral-200" />
              <div className="flex flex-col gap-[6px] w-[57.2%]">
                <div className="h-5 w-full rounded bg-neutral-200" />
                <div className="h-4 w-3/4 rounded bg-neutral-200" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop: Sidebar (24.2%) */}
      <div className="hidden sm:flex w-[24.2%] flex-col gap-5">
        <div className="h-48 w-full rounded bg-neutral-200" />
        <div className="h-48 w-full rounded bg-neutral-200" />
      </div>
    </div>
  </div>
)
